import netpack from "./../utils/netpack";
import actionConsts from "./../constants/actions";
import urlConsts from "./../constants/urls";
import { connectToFireBase } from "./firebase";
import { startTimer } from './timer';
import {
    scheduleMails,
    saveMailAsDraft,
    addReplyMailToThread,
    scheduleIndividualMail,
    getNextMail
} from "./mail/mailScheduler";
import store from "./../store/store";
import analytics from '../utils/segmentUtils'

import { frontendError } from "./error";

/**
 * [receiveInitData description]
 * @param  {Object} appInitData [app initial data]
 * @return {Object}             [action object to update initial data]
 */

export const getTutorialStatus = () => {
    netpack(urlConsts.TUTORIAL_STATUS)
        .get()
        .then(response => {
            setTutorialStatus(response.is_tutorial_completed);
        });
};

export const changeTutorialStatus = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    return netpack(urlConsts.TUTORIAL_COMPLETED)
        .post(options)
        .then(response => {
            if (response.success) {
                setTutorialStatus(payload.status);
            }
        })
        .catch(frontendError => {
            console.log(frontendError);
        });
};

const setTutorialStatus = status => {
    store.dispatch({
        type: actionConsts.SET_TUTORIAL_STATUS,
        payload: status
    });
};

const receiveInitData = appInitData => ({
    type: actionConsts.RECEIVE_INIT_DATA,
    payload: appInitData
});

const setSimulationMails = mails => {
    store.dispatch({
        type: actionConsts.SET_MAILS,
        payload: mails
    });
};

const updateUI = payload => ({
    type: actionConsts.CHANGE_WIDTH_AND_HEIGHT,
    payload
});

export const listenWindow = () => dispatch => {
    window.onresize = () => {
        dispatch(
            updateUI({
                width: window.innerWidth,
                height: window.innerHeight
            })
        );
    };
};

export const restartTutorial = () => {
    let response = store.getState();
    if (response.uiState.gameState.tempMailStorage) {
        connectToFireBase(
            response.uiState.gameState.tempMailStorage,
            true,
            store.dispatch,
            store.getState
        );
        // scheduleMails(response.uiState.gameState.tempMailStorage, store.dispatch, store.getState);
        // startTimer(response.uiState.user, true, 240, store.dispatch)
        store.dispatch({
            type: actionConsts.RESTART_TUTORIAL,
            payload: response.uiState.gameState.tempMailStorage.tutorial.tutorialData
        });
    }
};

export const fetchData = () => dispatch => {
    netpack(urlConsts.API_INIT)
        .get()
        .then(response => {
            dispatch(receiveInitData(response));
            return response;
        })
        .then(response => {
            //setting segment user
            analytics.identify(response.user.uliId, response.user);
            //setting segment group
            analytics.group(response.user.groupId, { groupId: response.user.groupId });

            //preloading images
            response.actors.clients.map(actor => {
                preloadImage(actor.gravatar);
            });
            response.actors.inActors.map(actor => {
                preloadImage(actor.gravatar);
            });

            let meetingArray = response.mails.filter(
                mail => mail.type === "meeting"
            );
            meetingArray.map(meeting => {
                meeting.survey.meetingImages.map(image => {
                    preloadImage(image);
                });
            });
        });
}

export const startTimerForSim = isTutorial => (dispatch, getState) => {
    let response = store.getState();
    connectToFireBase(response.uiState.gameState.tempMailStorage, isTutorial, dispatch, getState)
    dispatch({
        type: actionConsts.START_TIMER
    });

    // connectToFireBase(response.uiState.gameState.tempMailStorage, isTutorial, dispatch, getState)
    //if not tutorial, set sim mails
    if (!isTutorial) {
        // 	connectToFireBase(response.uiState.gameState.tempMailStorage, isTutorial, dispatch, getState)
        setSimulationMails(response.uiState.gameState.tempMailStorage);
    }
};

export const resetTimer = () => (dispatch, getState) => {
    dispatch({
        type: actionConsts.RESET_TIMER
    });
}

const preloadImage = url => {
    var img = new Image();
    img.src = url;
};

export const openHelpMenu = () => (dispatch, getState) => {
    dispatch({
        type: actionConsts.OPEN_HELP_MENU
    });
};

export const closeHelpMenu = () => (dispatch, getState) => {
    dispatch({
        type: actionConsts.CLOSE_HELP_MENU
    });
};

export const setMailThreads = payload => {
    store.dispatch({
        type: actionConsts.SET_MAIL_THREADS,
        payload: payload
    });
};

export const saveDraft = payload => {
    const options = {
        body: JSON.stringify(payload)
    };
    saveMailAsDraft(payload);
};

export const postData = payload => {
    const options = {
        body: JSON.stringify(payload)
    };
    addReplyMailToThread(payload); //Delete draft and add composed message

    //If tutorial, dont send post request
    if (!window.location.href.includes("tutorial")) {
        netpack(urlConsts.POST_API)
            .post(options)
            .then(response => {
                let responseMail = {
                    nextMailId: response.nextMailId,
                    primaryMailId: payload.primaryMailId,
                    actionTakenAt: payload.actionTakenAt
                };

                getNextMail(responseMail);
                // checkSecondaryMailDispatchTime(dispatch, responseMail, payload.primaryMailId, getState().timeData);
            })
            .catch(frontendError => {
                console.log(frontendError);
            });
    } else {
        let responseMail = {
            nextMailId: payload.responseMailId, //For tutorial, this value is changed
            primaryMailId: payload.primaryMailId,
            actionTakenAt: payload.actionTakenAt
        };
        getNextMail(responseMail);
    }
};

export const setSurveyCompleteFlag = payload => {
    terminateCall(payload).then(response => {
        if (response.sucess) {
            store.dispatch({
                type: actionConsts.SET_SURVEY_COMPLETED_FLAG,
                payload: payload.primaryMailId
            });
        }
    });
};

export const postSurveyResponse = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    //If tutorial, dont send post request
    if (!window.location.href.includes("tutorial")) {
        return netpack(urlConsts.SURVEY_POST_API)
            .post(options)
            .catch(frontendError => {
                console.log(frontendError);
            });
    } else {
        return {
            sucess: true
        };
    }
};

export const autoSaveSurveyAnswers = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    netpack(urlConsts.SURVEY_SINGLE_ANSWERS)
        .post(options)
        .then(response => {
            if (response.sucess) {
                saveSurveyAnswers(payload);
            }
        })
        .catch(frontendError => {
            console.log(frontendError);
        });
};

const saveSurveyAnswers = payload => {
    store.dispatch({
        type: actionConsts.SAVE_SURVEY_ANSWER,
        payload: payload
    });
};

export const startCall = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    //If tutorial, dont send call started request
    if (!window.location.href.includes("tutorial")) {
        return netpack(urlConsts.CALL_STARTED)
            .post(options)
            .then(response => {
                if (response.sucess) {
                    store.dispatch({
                        type: actionConsts.START_CALL,
                        payload: payload.primaryMailId
                    });
                }
            })
            .catch(frontendError => {
                console.log(frontendError);
            });
    } else {
        store.dispatch({
            type: actionConsts.START_CALL,
            payload: payload.primaryMailId
        });
    }
};

export const terminateCall = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    //If tutorial, dont send call started request
    if (!window.location.href.includes("tutorial")) {
        return netpack(urlConsts.TERMINATE_CALL)
            .post(options)
            .then(response => {
                return response;
            })
            .catch(frontendError => {
                console.log(frontendError);
            });
    } else {
        return { sucess: true };
    }
};

export const setCallEndedFlag = payload => {
    store.dispatch({
        type: actionConsts.TERMINATE_CALL,
        payload: payload.primaryMailId
    });
};

export const sendCallToVoiceMail = payload => {
    const options = {
        body: JSON.stringify(payload)
    };

    netpack(urlConsts.SEND_TO_VOICE_MAIL)
        .post(options)
        .then(response => {
            let responseMail = {
                nextMailId: response.nextMailId,
                primaryMailId: payload.primaryMailId,
                actionTakenAt: payload.actionTakenAt
            };
            getNextMail(responseMail);
        })
        .catch(frontendError => {
            console.log(frontendError);
        });
};

export const downloadReport = () => {
    return netpack(urlConsts.USER_REPORT)
        .get()
        .then(response => {
            return response;
        });
};



// WEBPACK FOOTER //
// /src/actions/init.js